// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_product_size_code: yup.string().label("Size code").required(),
  mr_product_size_name: yup.string().label("Size name").required()
})